import { render, staticRenderFns } from "./Observacion.vue?vue&type=template&id=bc768278&scoped=true&"
import script from "./Observacion.vue?vue&type=script&lang=js&"
export * from "./Observacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc768278",
  null
  
)

export default component.exports